/**
 * Program Benefits 1069 — KUK "Learn More".
 *
 * A tinted band of rich-text cards, each clamped with a View more / View less toggle
 * when its content runs past 96px. Ported from kuk-campus-portal
 * `components/Degree/LearnMore.tsx`.
 *
 * Every field maps to a column that already exists on `program_benefits` — the
 * variant adds no schema of its own beyond widening `program_benefits.variant`.
 */

export const PROGRAM_BENEFITS_1069_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Content cards",
  },

  DEFAULT_ROW: {
    id: "1",
    meta_title: "",
    meta_description: "",
    meta_priority: 1,
    meta_status: true,
  },

  PROGRAM_BENEFITS_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Heading",
      value: "Learn More",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "Learn More",
    },
    {
      fieldName: "title_start_color",
      label: "Heading colour",
      value: "#101112",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#101112",
    },
    {
      fieldName: "title_end_color",
      label: "Heading rule colour",
      value: "#9F1C33",
      valueType: "string",
      filedType: "COLOR",
      description: "The bar under the heading.",
      defaultValue: "#9F1C33",
    },
    {
      fieldName: "desktop_background_color",
      label: "Band background",
      value: "rgba(159, 28, 51, 0.1)",
      valueType: "string",
      filedType: "RGBA",
      defaultValue: "rgba(159, 28, 51, 0.1)",
    },
    {
      fieldName: "card_hover_background_color",
      label: "Card background",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "subtitle_color",
      label: "Card title colour",
      value: "#101112",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#101112",
    },
    {
      fieldName: "description_color",
      label: "Card body colour",
      value: "#101112",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#101112",
    },
    {
      fieldName: "load_more_button",
      label: "Expand label",
      value: "View more",
      valueType: "string",
      filedType: "INPUT",
      description: "Collapsing always reads \"View less\", as in the reference.",
      defaultValue: "View more",
    },
    {
      fieldName: "load_more_button_text_color",
      label: "Expand label colour",
      value: "#9F1C33",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#9F1C33",
    },
    {
      fieldName: "status",
      label: "Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Card title (optional)",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Content",
      fieldName: "meta_description",
      value: "",
      valueType: "string",
      filedType: "RICH_TEXT_EDITOR",
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS_1: [],
};
